import axios from "axios";
import { jwtDecode } from "jwt-decode";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:5000",
});

// Add an interceptor to check for token expiration
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken");
    
    if (token !== "undefined") {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          alert("Your session has expired. Please log in again.");
          localStorage.removeItem("accessToken");
          window.location.href = "/login"; // Redirect to login page
          return Promise.reject(new Error("Token expired"));
        }

        config.headers.Authorization = token;
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem("accessToken");
        window.location.href = "/login";
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response, 
    (error) => {
      if (error.response?.status === 401) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("accessToken");
        window.location.href = "/login"; 
      }
      return Promise.reject(error);
    }
  );

export default api;
